import {
  AUDIENCE_OPTIONS,
  DEFAULT_SALES_STAGES,
  RECIPIENT_GROUP_OPTIONS,
  isClientAudience,
} from './constants';

const optionLabel = (options, value) => {
  const option = options.find((item) => item.value === value);
  return option?.shortLabel || option?.label || value;
};

export const formatAudience = ({ audienceType, salesStages } = {}) => {
  if (isClientAudience(audienceType)) {
    return optionLabel(RECIPIENT_GROUP_OPTIONS, audienceType);
  }

  const stages = Array.isArray(salesStages) && salesStages.length > 0 ? salesStages : DEFAULT_SALES_STAGES;
  return stages.map((stage) => optionLabel(AUDIENCE_OPTIONS, stage)).join(' + ');
};
